module.exports = __webpack_public_path__ + "static/media/document-upload.de81ed8c.svg";